
var readMe_user = "Batch add template instruction:\n" +
  "Remind:\n" +
  "Maximum 50 pcs for 1 time. If 1 pc fails, batch add fails, pls batch add again.\n" +
  "1、 account  (Required)\n" +
  "Instruction: User account\n" +
  "Required: Required\n" +
  "Rule: 6-16 characters, Chinese/English/No./Underline only.\n" +
  "\n" +
  "2、 name (Required)\n" +
  "Instruction: Account name\n" +
  "Required: Required\n" +
  "Rule: 2-10 characters, Chinese/English/No./Underline only.\n" +
  "\n" +
  "3、 password (Required)\n" +
  "Instruction: Account password\n" +
  "Required: Required\n" +
  "Rule: 6-15 characters.\n" +
  "\n" +
  "4、 groupIdTemp (Optional)\n" +
  "Instruction: Initial group ID (seen in group MGT.) can only add groups owned by the company. Use : between groups. \n" +
  "Required: Optional\n" +
  "Example: 278:277:274\n" +
  "\n" +
  "5、 identityCard (Optional)\n" +
  "Instruction: User ID Card No.\n" +
  "Required: Optional\n" +
  "Rule: ID Card No. format\n" +
  "\n" +
  "6、 funcs (Optional)\n" +
  "Instruction: Account initial functions (1=Single call, 2=Location, 3=Friend, 4=Recording m, 5=TempGroup ,6=GroupCall). Use , between functions.\n" +
  "Required: Optional\n" +
  "Example: Functions=1,2,3,4,5,6\n" +
  "\n" +
  "7、 level  (Optional)\n" +
  "Instruction: Account intercom level. User intercom level (0=Low, 1=Medium, 2=High, 3=Ultra high). Default level: Low\n" +
  "Required: Optional\n" +
  "Example: 3\n" +
  "\n" +
  "8、 phone  (Optional)\n" +
  "Instruction: Account phone No.\n" +
  "Required: Optional\n" +
  "Rule: Phone No. format\n" +
  "\n" +
  "  9、 qb (Optional)\n" +
  "\n" +
  " Instruction: The account is divided into Q coins\n" +
  " Required: Optional\n：Optional\n" +
  " Rule: Only numbers can be entered, and less than 4,Q coins and orders can only be selected,Q coins are subject to the number of the first user \n" +
  "\n" +
  "  10、 orderId (Optional)\n" +
  "\n" +
  " Instruction: The user sets the order number, which can be used for scheduling, positioning, etc\n" +
  " Required: Optional\n" +
  " Rule: Only numbers can be entered, and Q coins can only be selected, and there can only be one after the order\n" +
  "\n"



const file = {

    confirm: {
      message: {
        confirmByExportExcel: "Ok to export Excel ?",
      }
    },

  export: {
    excel: {
      transaction:{
        fileName: "交易明细",
        //title与head是一一对应的
        title: ["订单号", "操作人账号", " 操作类型 ", "交易金额", "来源人账号 ",  "来源人操作前余额", "来源人操作后余额", "目标人账号", "目标人操作前余额", "目标人操作后余额", "创建时间"],
        head: ["orderId", "operatorAccount", "type", "value", "originAccount", "originBeforeBalance", "originAfterBalance", "targetAccount", "targetBeforeBalance",  "targetAfterBalance",  "createDate"]
      },
      //导出 代理表相关字段配置
      proxyTable: {
        fileName: "Proxy Info",
        //title与head是一一对应的
        title: ["Proxy Account", "Proxy Name", " Total number of enterprise ", "Total number of Registered User", "Total number of free User ",  "Total number of users", "Balance", "Creation Time", "Modify Time"],
        head: ["account", "name", "enterpriseCount", "terminalCount", "lifelongCount", "useTerminalCount", "balance", "createDate", "modifyDate"]
      },
      enterpiseTable: {
        fileName: "Enterpise Info",
        title: [" enterpise Account", " enterpise Name", "Total number of Registered User",  "Total number of free User ",  "Total number of users", "Balance", "Creation Time", "Modify Time"],
        head: ["account", "name", "terminalCount", "useTerminalCount", "lifelongCount", "balance", "createDate", "modifyDate"]
      },
      terminalTable: {
        fileName: "Terminal Info",
        title: ["account", "name", "phone", "function", "Voice level ","active time","end time"],
        head: ["account", "name", "phone", "funcs", "voicePrio","enableTime","maturityTime"]
      },
      terminalTable2nd: {
        fileName: "Terminal Info",
        title: ["account", "name", "phone", "function", "Voice level ","active time","end time","imei","model name"],
        head: ["account", "name", "phone", "funcs", "level","enableTime","expiredTime","imei","modelName"]
      },
      //title: ["IMEI号(必填)", "机器型号(必填)","账号(必填)","机器型号id","批次号","创建时间","修改时间","用户id", "企业id"],
      //         head: ["imei","modelName","account","modelId","batch","createDate","modifyDate","userId", "entId"]
      imeiTable: {
        fileName: "Imei Info",
       // title: ["imei(required)","modelName(required)", "account(required)", "modelId","batch","createDate","modifyDate","userId", "entId",],
     //   head: ["imei","modelName","account", "modelId","batch","createDate","modifyDate","userId", "entId"]
        title: ["imei(required)","account(required)", "modelName(required)","modelId","batch","createDate","modifyDate","userId", "entId",
          "enterpriseAccount","enterpriseName", "proxyAccount","proxyName","subAccount","subName","userName","password","groupIds","talkLevel","func","phone","idcard","remark","iccid"],
        head: ["imei","account","modelName","modelId","batch","createDate","modifyDate","userId", "entId","entAccount","entName",
          "proxyAccount","proxyName","subAccount","subName","","","","","","","","",""]
      },

      checkinIccid:{
        fileName: "接入iccidi数据导出",
        title: ["账号","姓名","终端id","企业账号","企业名称","代理名称","订单id","imei1", "imei2","iccid1","iccid2",
          "QB到期时间","订单激活时间","订单开始时间","订单结束时间"],
        head: ["account","name","terminalId","entAccount","entName","proxyName","orderId","imei_1", "imei_2","iccid_1","iccie_2",
          "qbExpireDate","activeTime","enableTime","maturityTime"]
      },

      patrolCount:{
        fileName: "巡更时间统计数据导出",
        title: ["计划名称","计划总数","上报总数","上报有效数","上报无效数","上报有效率","上报无效率"],
        head: ["planName","planCount","planCount1","validTaskCount","notValidTaskCount","planCount3","planCount4"]
      },

      groupUser: {
        fileName: "群组用户信息表",
        title: ["群组名称","账号", "姓名", "电话", "功能", "对话等级","启用时间","到期时间"],
        head: ["curGroupName","account", "name", "phone", "funcs", "level","enableTime","maturityTime"]
      },
    }
  },
  import:{
    template:{
      user:{
        zipName:'Add user templates in batches',
        fileName:'Terminal Info',
        title:['account(required)', 'name(required)', 'password(required)', 'groupIdTemp', 'identityCard', 'funcs', 'voicePrio', 'phone', 'remark', 'iccid','qb','orderId','instruction book'],
        header:['account', 'name', 'password', 'groupIdTemp', 'identityCard', 'funcs', 'voicePrio', 'phone', 'remark', 'iccid','qb','orderId'],
        readMe:{
          fileName:'Description.txt',
          content:readMe_user
        },
      },
    }
  },

  iccidImport: {
    template: {
      user: {
        zipName:'Add iccid templates in batches',//批量新增iccid模板
        fileName:'Iccid information table', //iccid信息表
        title: ["iccid(required)"],//iccid必填
        header: ["iccid"],
       /* readMe:{
          fileName:'批量新增模板说明.txt',
          content:readMe_user
        },*/
      }
    }
  },

  importLifeFree: {
    template: {
      user: {
        zipName:'Add IMEI in batch',//批量新增IMEI
        fileName:'IMEI information table',//IMEI信息表
        title: ["IMEI(required)","model(required)","startAccount","remark"],//IMEI号(必填)
        header: ["IMEI","model","startAccount","remark"],//IMEI
        //title: ["ieme", "account", "model account","batch","create date","modify date","model name","user id", "enterprise id",],
        title_ent: ["imei(required)","account(required)","userName","password","groupIds","talkLevel","func","phone","idcard","remark","iccid"],
        header_ent: ["imei","account","userName","password","groupIds","talkLevel","func","phone","idcard","remark","iccid"],
       /* readMe:{
          fileName:'批量新增IMEI说明.txt',
          content:readMe_user
        },*/
      }
    }
  },

  //专网导入
  privateImport:{
    template:{
      zipName:'',
      fileName:'专网信息表',
      title: ["专网企业(必填)","专网id(必填)"],
      header: ["eid","tid"],
      readMe:{
        fileName:'批量新增模板说明.txt',
        content:readMe_user
      },
    }
  },

  track808:{
    template:{
      zipName:'',
      fileName:'808信息表',
      title: ["808协议设备id(必填)","ip(必填)","端口号(必填)"],
      header: ["agreementId","ip","port"],
    }
  },

};




export default file;



// WEBPACK FOOTER //
// ./src/api/lang/modules/file/file_en.js